import { FilterRulesProps } from '../models/common';
import { getWindow } from './general';

/**
 * Funtion is made to return boolean value based on policy doc
 * and user creds.
 */
export const isUserAllowedToViewAllPurchases = (
  role: string,
  type: string,
): boolean => {
  let shouldRender = true;

  if (type === 'b2b') {
    const getPDocID = getWindow()?.THD_CUST_ACCOUNT_OM?.pdocid ?? '';
    const rules: FilterRulesProps[] = getPDocID
      ? JSON.parse(Buffer.from(getPDocID, 'base64').toString())
      : [];

    rules.forEach((rule: FilterRulesProps) => {
      if (
        rule.actions.includes('view') &&
        rule.resources[0] === 'order' &&
        rule.filters
      ) {
        shouldRender = !rule.filters.find(
          ({ name, filterCandidate }) =>
            name === 'purchaserPHFilter' &&
            filterCandidate?.user?.role === role.toUpperCase() &&
            filterCandidate?.user?.type === type.toUpperCase(),
        );
      }
    });
  }

  return shouldRender;
};
